import { ExtendedPaletteColorName } from '@robinhood/design';
import { LinearGradientColor } from '@robinhood/design/product/themes';

const createGoldGradient = (angle: number): LinearGradientColor => ({
  angle,
  colorStops: [
    { color: ExtendedPaletteColorName.BankingAccentLight, stop: 0 },
    { color: ExtendedPaletteColorName.BankingAccentDark, stop: 1 },
  ],
});

export const GoldGradient = createGoldGradient(90);
export const GoldGradientVertical = createGoldGradient(180);
